@switch (target) {
@case (targetAudienceGender.All) {
   {{"manageSurveys.maleAndFemale" | translate}}
 }
@case (targetAudienceGender.Male) {
  {{"fields.male" | translate}}
 }
@case (targetAudienceGender.Female) {
  {{"fields.female" | translate}}
 }
}
